import { ApiTags, rootApi } from "../../../../services/rootApi";

const TAG = ApiTags.AcademicRegistration;
export interface IABCForm {
  id: string
  aadharName: string,
  aadharNumber: string,
  dob: string,
  gender: string,
  mobile: string,
}

export interface ABCResponse {
  abC_ACCOUNT_ID: string;
  message: string;
  status_code: number;
  status: string;
}

// Define the structure of a record
export interface BoardingPass {
  id: string;
  studentJguId: string;
  student: string;
  batch: string;
  academicYear: string;
  academicSessionCopy: string;
  semester: string;
  program: string;
  emailId: string;
  reportingGate: string;
  reportingDate: string; // ISO date string
  faceSyncing: boolean;
  studenttype: number;
  tuitionFeePaid: boolean;
  hostelFeePaid: boolean;
  abcid: boolean;
  boardingPassUrl: string
}

const getTags = (entities: BoardingPass[]) => [
  ...entities.map((p) => ({ type: TAG, id: p.id })),
  TAG,
];

const boardingPassApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    createAbcId: builder.mutation<ABCResponse, Partial<IABCForm>>({
      query: (payment) => ({
        url: "/AbcID",
        method: "POST",
        body: payment
      }),
      invalidatesTags: (result) => result ? [{ type: TAG, id: result.abC_ACCOUNT_ID }, TAG] : [TAG]
    }),
    getBoardingPass: builder.query<BoardingPass, { studentId: string }>({
      query: ({ studentId }) => `BoardingPass/student(${studentId})`,
      providesTags: (result) => (result ? getTags([result]) : [TAG]),
    }),
  }),
});

export const {
  useCreateAbcIdMutation,
  useGetBoardingPassQuery,
  useLazyGetBoardingPassQuery,
} = boardingPassApi;
